import { RegisterUser } from "../actionTypes/registerUser";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case RegisterUser.REGISTER_USER_SUCCESS:
      return {
        ...state,
        ...action.result,
      };
    default:
      return { ...state };
  }
};
